// Lit Context binding for the ChatStateStore.
//
// Pattern (per @lit/context docs):
//
//   1. The root <emma-chat> element creates a ChatStateStore instance and
//      provides it via @provide / new ContextProvider on this context key.
//
//   2. Descendant components consume via @consume — they get the
//      *instance reference*. Reactive updates are handled by
//      StateConsumerController (see state-consumer-controller.ts) which
//      subscribes to the store's listener list and triggers requestUpdate.
//
//   3. The context value (the instance reference) does NOT change across
//      the widget's lifetime. The mechanism that signals "state changed" is
//      the listener subscription on the store, NOT the context machinery.
//
// Consumer template (full example for T05+):
//
//   import { LitElement, html } from 'lit';
//   import { customElement, property } from 'lit/decorators.js';
//   import { consume } from '@lit/context';
//   import { chatStateContext } from '../state/chat-state-context.js';
//   import { StateConsumerController } from '../state/state-consumer-controller.js';
//   import type { ChatStateStore } from '../state/chat-state-store.js';
//
//   @customElement('emma-chat-something')
//   class EmmaChatSomething extends LitElement {
//     @consume({ context: chatStateContext })
//     @property({ attribute: false })
//     store!: ChatStateStore;
//
//     private _stateConsumer = new StateConsumerController(this, () => this.store);
//
//     render() {
//       return html`<div>${this.store.state.lastMode}</div>`;
//     }
//   }

import { createContext } from '@lit/context';
import type { ChatStateStore } from './chat-state-store.js';

export const chatStateContext = createContext<ChatStateStore>(Symbol('emma-chat-state'));
